import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  DEFAULT_TOKEN_DECIMALS,
  MARGINX_BRANDING,
  RPC_API_KEY,
} from "./shared";

// ============================================
// ARBITRUM (Chain ID: 42161)
// ============================================
export const arbitrumConfig: ChainConfig = {
  chainId: ChainIdEnum.ARBITRUM,
  name: "Arbitrum One",
  shortName: "arbitrum",
  isTestnet: false,
  rpcUrls: [`https://arb-mainnet.g.alchemy.com/v2/${RPC_API_KEY}`],
  explorerUrl: "https://arbiscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      "usdc-native": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
      usdt: "",
      weth: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
      wbtc: "",
      l2usdc: "0x643aaB1618c600229785A5E06E4b2d13946F7a1A",
      l2usdt: "",
      l2weth: "0xB9D571c1EC576300f01ddfA5A082D9c571E45e36",
      l2wbtc: "",
      govToken: "",
    },
    multichain: {
      socketHelper: "0xfb73dfff0ae6aa94559b1b17421cf42e198b8d22",
      vault: {
        usdc: "0x80d40e32FAD8bE8da5C6A42B8aF1E181984D137c",
        "native-usdc": "0x7711C90bD0a148F3dd3f0e587742dc152c3E9DDB",
        weth: "0x90bFB3C35ddfBbA42D998414F0ff1eADD430E161",
      },
      connector: {
        usdc: "0x69Adf49285c25d9f840c577A0e3cb134caF944D3",
        "native-usdc": "0x070FeadF2208303d341D1d2DA6aa41395f8BCE43",
        weth: "0x63D8934c1fC89F57b17AB5e14db52bB07D577C0F",
      },
      withdrawalConnector: {
        usdc: "0x73019b64e31e699fFd27d54E91D686313C14191C",
        "native-usdc": "0x47DF1018Ad9CEA463C014f7Bdb39A531C2024510",
        weth: "0xF19516273AfF391293ff79822c08e66932b77AA6",
      },
      l2WithdrawProxy: "0xE3EF8bEE5c378D4D3DB6FEC96518e49AE2D2b957",
    },
  },
  signingDomain: { name: "MarginX Mainnet", version: "1" },
  socketL2ChainId: 2999,
  branding: MARGINX_BRANDING,
};
